import foresLogo from "../../../assets/product/fores.png";
import pMobiAdmin from "../../../assets/product/mobiAdmin.png";
import pMobiOffice from "../../../assets/product/mobiOffice.png";
import pMobiRoute from "../../../assets/product/mobiRoute.png";
import pMobiSupport from "../../../assets/product/mobiSupport.png";
import pMobiShop from "../../../assets/product/mobiShop.png";
import pMobiSales from "../../../assets/product/mobiSales.png";
import pMobiPack from "../../../assets/product/mobiPack.png";

// Gecici ornek urun listesi — mobi urun ailesi. Backend getProducts() gercek veri
// dondurunce bu fallback (length kontrolu ile) devre disi kalir. Urun kodlari
// ticket-constants PRODUCT_TEXT ile uyumludur (10=mobiOffice, 11=mobiSales, ...).

export interface ProductCard {
    ref: number;
    code: number;
    name: string;
    description: string;
    image: string;
    is_active: boolean;
}

export const MOCK_PRODUCTS: ProductCard[] = [
    { ref: 1, code: 10, name: "mobiOffice", description: "Saha satış ve ön muhasebe ofis çözümü", image: pMobiOffice, is_active: true },
    { ref: 2, code: 11, name: "mobiSales", description: "Mobil satış ve sipariş yönetimi", image: pMobiSales, is_active: true },
    { ref: 3, code: 12, name: "mobiShop", description: "B2B online sipariş platformu", image: pMobiShop, is_active: true },
    { ref: 4, code: 13, name: "mobiSupport", description: "Müşteri destek ve ticket yönetimi", image: pMobiSupport, is_active: true },
    { ref: 5, code: 14, name: "mobiRoute", description: "Rota planlama ve sevkiyat yönetimi", image: pMobiRoute, is_active: true },
    { ref: 6, code: 15, name: "mobiAdmin", description: "Yönetim ve yapılandırma paneli", image: pMobiAdmin, is_active: true },
    { ref: 7, code: 16, name: "mobiPack", description: "Depo ve paketleme yönetimi", image: pMobiPack, is_active: false },
    { ref: 8, code: 100, name: "Fores", description: "Entegrasyon ve veri platformu", image: foresLogo, is_active: true },
];
